import { stringify } from 'query-string';
import React, { useState } from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router';
import { toast } from 'react-toastify';
import StoreX, { store } from '../../redux/oldStore';
import { IState, ReduxMap } from '../../redux/redux';
import { FullShoppingCartItem, InvoicePaymentRequestResponse, Product, ProductsResponse } from '../../utils/CommonTypes/StoreTypes';
import { ServerResponse } from '../../utils/Server';
import { formatMoney, sanitizeHtml } from '../../utils/Tools';
import Icon, { IconType } from '../Icon/Icon';
import Modal from '../Modal/Modal';
import ProductInModal from './ProductInModal';
import ShoppingCart from './ShoppingCart';
import { useLocation } from 'react-router';
import RegistrationStepper from '../RegistrationStepper/RegistrationStepper';

interface StoreFrontOwnProps {
    notRegistrationStore?: boolean;
}

interface StoreFrontProps extends StoreFrontOwnProps, IState { }

const StoreFront = (props: StoreFrontProps) => {
    const { userId, invoice } = useParams();
    const navigate = useNavigate();
    const location = useLocation();

    const [inventory, setInventory] = useState<Product[]>([]);
    const [fullProductsResponse, setFullProductsResponse] = useState<ProductsResponse>();
    const [chosenProduct, setChosenProduct] = useState<Product>();
    const [productModalOpen, setProductModalOpen] = useState(false);
    const [shoppingCart, setShoppingCart] = useState<FullShoppingCartItem[]>([]);
    const [cartCount, setCartCount] = useState(0);
    const [couponsUsed, setCouponsUsed] = useState<any[]>([]);
    const [orderId, setOrderId] = useState<string>(invoice);

    useEffect(() => {
        init();
    }, []);

    const init = (orderIdProp?: string) => {
        let storeUrl = userId ? `../store/products/${userId}` : `../store/products`;
        store.server.postApi<ServerResponse<ProductsResponse>>(storeUrl, { orderId: orderIdProp ?? orderId }).then((x) => {
            if (x.Success) {
                handleProductsResponse(x.Value);
            } else {
                toast.error(`${x.Message}`, { autoClose: false });
            }
        });
    };

    const handleProductsResponse = (stuff: ProductsResponse) => {
        setFullProductsResponse(stuff);
        console.log(`Fee Options`, stuff.registrationFeeOptions);
        setInventory(stuff.products);
        setCartCount(stuff.cartCount);
        let contentsOfCart = stuff.products.reduce((prev, curr) => {
            return [
                ...prev,
                ...curr.InBag.map((x) => {
                    return { ...x, Cost: curr.Cost, Name: curr.Name, Id: curr.Id, Removeable: curr.Removable, Limit: curr.Limit };
                }),
            ];
        }, new Array<FullShoppingCartItem>());
        setShoppingCart(contentsOfCart);
        if (stuff.NewRecord && stuff.products.length === 0 && stuff.total === 0) {
            ProcessPayment('No Fee', false, stuff);
        }
    };

    const handleContinue = (ignoreCart: boolean | null | undefined) => {
        if (shoppingCart && fullProductsResponse?.total !== 0 && !ignoreCart) {
            //cart not empty.
            toast.warning(`You must purchase the items in your cart before you may continue.`);
            return;
        }
        ProcessPayment('No Fee', false);
    };

    const ProcessPayment = (reason: string | undefined, makeInvoice: boolean, stuff?: ProductsResponse) => {
        let url = '';
        if ((stuff || fullProductsResponse)?.NewRecord) {
            url = '../Store/ProcessPaymentAndRegister';
        } else {
            url = '../Store/ProcessPayment';
        }
        store.server.postApi<ServerResponse<InvoicePaymentRequestResponse>>(url, { userId: userId, reason: reason, makeInvoice: makeInvoice }).then(async (res) => {
            if (res.Success) {
                if (!res.Value.Pass) {
                    setOrderId(res.Value.OrderId);
                    toast.error(`Payment Failed: ${res.Value.Message}`, { autoClose: false });
                }
                else if (res.Value.NextRecordPath) {
                    if (userId) await store.server.postApi<ServerResponse<any>>('../UserProfile/MarkRegistrationStepCompleted', { userId: userId, step: 'store' });
                    navigate(`${res.Value.NextRecordPath}/${location.search}`);
                    return;
                } else if (res.Value.OrderId) {
                    let redirectUrl = StoreX.BuildUrl(`/app/purchase/invoice/${res.Value.OrderId}`);
                    window.location.href = redirectUrl;
                } else {
                    toast.success(`Payment Processed Successfully.`);
                }
            } else {
                if (res.Value?.Message) toast.error(`${res.Value.Message}`, { autoClose: false });
            }
        });
    };

    const handleProductClick = (prod: Product) => {
        setChosenProduct(prod);
        setProductModalOpen(true);
    };

    const handleProductClose = (open?: boolean) => {
        setChosenProduct(undefined);
        setProductModalOpen(false);
    };

    const progressBar = () => {
        return (
            <>
                {fullProductsResponse?.NewRecord && userId && <RegistrationStepper personId={userId} currentStep="store" />}
            </>
        );
    }

const mappedProducts = inventory
    .filter((x) => !x.IsHidden && (!x.InBag || x.InBag.length < x.Limit) && !x.GroupWith)
    .map((prod, i) => {
        return (
            <div key={`${prod.Id}-${i}`} className="click store-item hover-shadow" onClick={() => handleProductClick(prod)}>
                {prod.ImageUrl ? (
                    <div className="store-item-image">
                        <img src={prod.ImageUrl} alt={prod.Name} />
                    </div>
                ) : (
                    <div className="store-item-no-image">
                        <Icon type={IconType.shop} addClass="fa-5x" />
                    </div>
                )}
                <div>
                    <strong>{prod.Name}</strong>
                </div>
                <div>{formatMoney.format(prod.Cost)}</div>
                <div className="ellipsis item-description">{prod.Description}</div>
            </div>
        );
    });

return (
    <div className="col-sm-12">
        {(props.notRegistrationStore ? false : true) && fullProductsResponse?.headerText && <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(fullProductsResponse.headerText) }} />}
        <div>
            {progressBar()}
            {inventory && inventory.filter((x) => !x.IsHidden && (!x.InBag || x.InBag.length < x.Limit)).length > 0 && (
                <>
                    {props.Settings?.text.RegistrationStoreHeader && <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(props.Settings.text.RegistrationStoreHeader) }} />}
                    <div className="store-items">{mappedProducts}</div>
                </>
            )}

            <hr />
        </div>

        {shoppingCart && shoppingCart.length > 0 && fullProductsResponse ? (
            <>
                <ShoppingCart
                    cartContents={shoppingCart}
                    cartCount={cartCount}
                    couponsUsed={couponsUsed}
                    fullProductResponse={fullProductsResponse}
                    handleProductsResponse={handleProductsResponse}
                    userId={userId ?? null}
                    newUsersContinue={ProcessPayment}
                    orderId={orderId}
                    altCheckoutPaymentMethod={fullProductsResponse.AltCheckoutPaymentMethod}
                    notRegistrationStore={props.notRegistrationStore ?? false}
                    refreshCart={(orderId?: string) => {
                        setOrderId(orderId);
                        init(orderId);
                    }}
                />
                {progressBar()}

                <hr />
            </>
        ) : inventory && inventory.length > 0 ? (
            <>
                <div className="alert alert-info">
                    <h4>
                        <Icon type={IconType.shoppingCart} /> Cart Empty
                    </h4>
                    Select an item to add it to your cart.
                </div>
            </>
        ) : (
            <></>
        )}

        {fullProductsResponse?.NewRecord && shoppingCart && fullProductsResponse.total === 0 && (
            <>
                <button className="btn btn-success save-and-continue" onClick={() => handleContinue(false)}>
                    <Icon type={IconType.save} /> {fullProductsResponse.continueBtnText ?? 'Continue.'}
                </button>
            </>
        )}
        {productModalOpen && chosenProduct && (
            <Modal title={' '} setModalOpen={handleProductClose} size="l">
                <ProductInModal product={chosenProduct}
                    childProducts={inventory.filter(i => i.GroupWith === chosenProduct.Id)}
                    handleProductClose={handleProductClose} handleProductsResponse={handleProductsResponse} userId={userId ?? null} orderId={orderId} />
            </Modal>
        )}
        <br />
        <br />

        {fullProductsResponse?.footerText && <div dangerouslySetInnerHTML={{ __html: sanitizeHtml(fullProductsResponse.footerText) }} />}
    </div>
);
};

// Export the component with proper Redux connection that allows additional props
const ConnectedStoreFront = ReduxMap(StoreFront) as React.ComponentType<StoreFrontOwnProps>;

export default ConnectedStoreFront;
